import MongoModel from './MongoModel'
import { date, number, string, required } from 'vue-mc/validation'
import store from '@/store'

export default class Expense extends MongoModel {
  modelName = 'Expense'
  collection = 'expenses'
  autoFields = true

  defaults () {
    const org = store.getters['organizations/currentOrganization']

    const customProperties = {}
    for (const prop of store.getters['organizations/customProperties']('expense')) {
      customProperties[prop.key] = null
    }

    return {
      id: null,
      organization: org.id,
      project: '',
      name: '',
      cost: null,
      date: new Date().toISOString().slice(0, 10),
      ...customProperties
    }
  }

  // When saved
  mutations () {
    return {
      estimatedCost: (val) => Number(val) || null
    }
  }

  validation () {
    return {
      organization: string.and(required),
      project: string.and(required),
      cost: number.and(required),
      date: date
    }
  }
}
